<template>
    <transition>
        <div class="orders-list" v-if="orderList.length">
            <div class="container">
                <h1 class="title is-3 has-text-grey pl-2 pt-5">
                    BESTELLVERLAUF
                </h1>
            </div>
            <div v-for="(item, index) in orderList" :key="index">
                <OrderListElement :item="item"></OrderListElement>
            </div>
        </div>
    </transition>
</template>

<script>
import OrderListElement from './OrderListElement';
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            isLoading: true,
        };
    },
    name: 'OrderList.vue',
    components: { OrderListElement },
    computed: {
        ...mapGetters(['isUserLoggedIn', 'orderList']),
    },
    created() {
        if (!this.isUserLoggedIn) {
            this.$router.push('/login');
        } else {
            this.$store.dispatch('fetchUserOrders').then(() => {
                this.isLoading = false;
            });
        }
    },
};
</script>

<style scoped></style>
